import { observer } from 'mobx-react'
import { ReactComponent as User } from '../../assets/user.svg'
import { ReactComponent as Global } from '../../assets/globe.svg'
import { ReactComponent as FB } from '../../assets/new-icons/fb.svg'
import { ReactComponent as Insta } from '../../assets/new-icons/insta.svg'
import { ReactComponent as Linkedin } from '../../assets/socials/akar-icons_linkedin-fill.svg'
import { ReactComponent as Tw } from '../../assets/socials/akar-icons_twitter-fill.svg'
import { ReactComponent as Search } from '../../assets/footer/search.svg'
import { ReactComponent as Google } from '../../assets/socials/googleplay.svg'
import { ReactComponent as Apple } from '../../assets/socials/appstore.svg'
import { ReactComponent as Hua } from '../../assets/socials/huaw.svg'
import { ReactComponent as Plus } from '../../assets/footer/plus.svg'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import GlobalState, {
  changeLocaleState,
  changeCoopState,
} from '../../stores/GlobalState'
import './index.scss'
import { Fragment, useEffect, useRef, useState } from 'react'
import ContentState from '../../stores/ContentState'
import classNames from 'classnames'
import SearchState, { searchArticles } from '../../stores/SearchState'
import { AccountModel } from '../../stores/UserModel'
import SeoBlock from '../common/SeoBlock'
const Footer = observer(() => {
  const { pathname } = useLocation()
  const [width, setWidth] = useState(window.innerWidth)
  useEffect(() => {
    if (!ContentState.home) return
    if (pathname != '/') return
    window.addEventListener('resize', () => {
      const screens = document.querySelectorAll('.screen:not(.footer)')
      let footerTop = 0

      screens.forEach((s) => (footerTop += s.getBoundingClientRect().height))
      let offset = footerTop

      if (!document.querySelector('.container')) return
      ;(document.querySelector('.container') as any).onscroll = () => {
        let scrollPos = (document.querySelector('.container') as any).scrollTop

        if (scrollPos >= offset) {
          document.querySelector('.header')?.classList.add('absolute')
        } else document.querySelector('.header')?.classList.remove('absolute')
      }
    })
  }, [ContentState.home])

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  if (!ContentState.footer || !ContentState.menu) return <></>
  let lang = GlobalState.currentLocale.lang.includes('En')
    ? '/en/'
    : GlobalState.currentLocale.lang.includes('ру')
    ? '/ru/'
    : '/'

  return (
    <footer
      className={classNames('footer screen', pathname == lang && 'footer-home')}
      id="footer"
    >
      {ContentState.home?.seo &&
      ContentState.home?.seo?.title?.length &&
      pathname == lang ? (
        <div className="footer__seo">
          <SeoBlock seo={ContentState.home?.seo} />
        </div>
      ) : (
        <></>
      )}
      <div className="footer__content">
        <div className="footer__row links-list">
          {ContentState.footer?.cols?.map((f, i) => (
            <div className="footer__col" key={i}>
              {f?.map((fi, idx) => (
                <a
                  href={fi.link}
                  key={idx}
                  className={classNames(
                    'footer__link',
                    fi.link.includes('#') && 'disable-link',
                  )}
                  target={fi.link.includes('http') ? '__blank' : ''}
                >
                  <span>{fi.title}</span>
                </a>
              ))}
            </div>
          ))}
        </div>
        <div className="footer__row">
          <FooterMenu
            dt={ContentState.footer?.cols.slice(0, 2)}
            title={ContentState.footer.companies}
          />
          <FooterMenu
            dt={ContentState.footer?.cols.slice(2)}
            title={ContentState.footer.addInfo}
          />
        </div>
        <div className="footer__block">
          <div className="footer__block-col">
            <div
              className="footer__personal"
              onClick={() => {
                let lang = GlobalState.currentLocale.lang.includes('En')
                  ? '/en'
                  : GlobalState.currentLocale.lang.includes('ру')
                  ? '/ru'
                  : ''

                window.location.href = AccountModel.email
                  ? `${lang}/account/`
                  : `${lang}/login/`
              }}
            >
              {/* <User /> */}
              <img
                src={
                  "data:image/svg+xml,%3Csvg viewBox='0 0 17 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8.5' cy='5.5' r='4.5' stroke='black'/%3E%3Cpath d='M16 20C16 16.134 12.6421 13 8.5 13C4.35786 13 1 16.134 1 20' stroke='black'/%3E%3C/svg%3E%0A"
                }
              />
              <span>{ContentState.footer.cabinetTitle}</span>
            </div>
            <div className="footer__locale" onClick={changeLocaleState}>
              {/* <Global /> */}
              <img src="data:image/svg+xml,%3Csvg viewBox='0 0 35 35' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.4504 33.7585C26.5459 33.7585 33.9193 26.3851 33.9193 17.2896C33.9193 8.19406 26.5459 0.820679 17.4504 0.820679C8.35483 0.820679 0.981445 8.19406 0.981445 17.2896C0.981445 26.3851 8.35483 33.7585 17.4504 33.7585Z' stroke='%23000' stroke-width='1.37241'/%3E%3Cpath d='M0.981445 17.2896H33.9193' stroke='%23000' stroke-width='1.37241'/%3E%3Cpath d='M17.4508 0.820801C21.5702 5.33057 23.9112 11.1831 24.0384 17.2897C23.9112 23.3963 21.5702 29.2488 17.4508 33.7586C13.3315 29.2488 10.9905 23.3963 10.8633 17.2897C10.9905 11.1831 13.3315 5.33057 17.4508 0.820801V0.820801Z' stroke='%23000' stroke-width='1.37241' stroke-linejoin='round'/%3E%3C/svg%3E%0A" />

              <div className="footer__locale-block">
                <div className="footer__locale-top">
                  {GlobalState.currentLocale.country}
                </div>
                <div className="footer__locale-bottom">
                  {GlobalState.currentLocale.lang}
                </div>
              </div>
            </div>
            <div className="footer__socials">
              <a
                href={ContentState.footer!.socials!.fb.link}
                target={'_blank'}
                className="footer__socials-item"
                rel="noreferrer"
              >
                <FB />
              </a>
              <a
                href={ContentState.footer!.socials!.insta.link}
                target={'_blank'}
                rel="noreferrer"
                className="footer__socials-item"
              >
                <Insta />
              </a>
              <a
                href={ContentState.footer!.socials!.linkedin.link}
                target="_blank"
                rel="noreferrer"
                className="footer__socials-item"
              >
                <Linkedin />
              </a>
              <a
                href={ContentState.footer!.socials!.twitter.link}
                target={'_blank'}
                rel="noreferrer"
                className="footer__socials-item"
              >
                <Tw />
              </a>
            </div>
            <div
              className="footer__phone"
              onClick={() =>
                (window.location.href = `tel:${ContentState.footer!.phone}`)
              }
            >
              {ContentState.footer.phone}
            </div>
          </div>
          <div className="button white" onClick={changeCoopState}>
            <span> {ContentState.footer.coopButton}</span>
          </div>
        </div>
      </div>
      <div className="footer__sub-bottom">
        <FooterSearch />
        <div className="footer__apps">
          <Google
            className="footer__apps-item"
            onClick={() =>
              window.open(ContentState.footer!.apps!.google.link, '_blank')
            }
          />
          <Apple
            className="footer__apps-item"
            onClick={() =>
              window.open(ContentState.footer!.apps!.apple.link, '_blank')
            }
          />
          {/* <Hua
            className="footer__apps-item"
            onClick={() =>
              window.open(ContentState.footer!.apps!.hua.link, '_blank')
            }
          /> */}
        </div>
      </div>
      <div className="footer__bottom">
        <p className="footer__text">{ContentState.footer.company}</p>
        <p className="footer__text">{ContentState.footer.rules}</p>
      </div>
    </footer>
  )
})

export default Footer

const FooterMenu = observer(({ title, dt }: { title: string; dt: any }) => {
  const [active, setActive] = useState(false)
  const top = useRef<any>(null)
  const ref = useRef<any>(null)

  useEffect(() => {
    if (!ref.current) return
    ref.current.style.setProperty(
      '--footer-col-height',
      ref.current.scrollHeight + 'px',
    )
  })

  return (
    <div className={classNames('footer__menu', active && 'active')}>
      <div
        className={classNames('footer__menu-top', active && 'active')}
        onClick={() => setActive(!active)}
        ref={top}
      >
        {title} <Plus />
      </div>
      <div className="footer__menu-list" ref={ref}>
        {dt?.map((f: any, i: number) => (
          <Fragment key={i}>
            {f?.map((fi: any, idx: number) => (
              <a
                href={fi.link}
                key={idx}
                className="footer__link"
                target={fi.link.includes('http') ? '__blank' : ''}
              >
                <span>{fi.title}</span>
              </a>
            ))}
          </Fragment>
        ))}
      </div>
    </div>
  )
})

export const FooterSearch = observer(() => {
  const navigate = useNavigate()
  const [value, setValue] = useState('')
  const [isFocus, setFocus] = useState(false)

  const search = (e: any) => {
    if (value.length) {
      searchArticles(value, GlobalState.currentLocale.lang).then(() => {
        let lang = GlobalState.currentLocale.lang.includes('En')
          ? '/en'
          : GlobalState.currentLocale.lang.includes('ру')
          ? '/ru'
          : ''
        navigate(`${lang}/search`)
        window.scroll(0, 0)
        setValue('')
      })
    }
    e.preventDefault()
  }

  return (
    <form action="/search" onSubmit={(e) => search(e)}>
      <div className={classNames('footer__search', isFocus && 'focus')}>
        <Search />
        <input
          className="input"
          type={'search'}
          onChange={(e) => setValue(e.target.value)}
          value={value}
          placeholder={
            !isFocus
              ? GlobalState.currentLocale.lang.includes('Eng')
                ? 'Search...'
                : GlobalState.currentLocale.lang.includes('ру')
                ? 'Поиск...'
                : 'Пошук...'
              : ''
          }
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
        />
      </div>
    </form>
  )
})
